import { FC, useState } from "react";
import { EmployeeChangeLogItem } from "./EmployeeChangeLogItem";
import { EmployeeChangeLogEntry } from "types/Employee";

interface Props {
  changeLog: EmployeeChangeLogEntry[];
}

export const EmployeeChangeLogChanges: FC<Props> = ({ changeLog }) => {
  const firstEntry = changeLog[0]?.modifiedAt;
  const [open, setOpen] = useState<string>(firstEntry);

  const [prevFirstItem, setPrevFirstItem] = useState<string>(firstEntry);
  if (firstEntry !== prevFirstItem) {
    setPrevFirstItem(firstEntry);
    setOpen(firstEntry);
  }

  function handleToggleOpen(id: string) {
    setOpen(id);
  }

  return (
    <ul className="content">
      {changeLog?.map((item) => (
        <li key={item.modifiedAt}>
          <EmployeeChangeLogItem
            data={item}
            open={open === item.modifiedAt}
            onToggleOpen={() => handleToggleOpen(item.modifiedAt)}
          ></EmployeeChangeLogItem>
        </li>
      ))}
    </ul>
  );
};
